import { HTMLProps } from 'react';
import { cn } from '@/utils/shadcn';
import Logo from '@/components/icons/Logo.svg?react';

const NavHeader = ({ className, ...props }: HTMLProps<HTMLElement>) => {
  return (
    <nav
      className={cn(
        'w-full relative bg-dominant-surface-default dark:bg-dominant-surface-tinted',
        className,
      )}
      {...props}
    >
      <div
        className={
          'p-3 md:px-6 lg:py-4 xl:p-6 mx-auto w-full lg:max-w-360 flex justify-center lg:justify-start'
        }
      >
        <Logo className={'fill-logo-primary h-7 md:h-8'} />
      </div>
    </nav>
  );
};

export { NavHeader };
